import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import * as _ from 'lodash';
import { RepAssessment, CacheService } from "mapfre-auditlib";
import { map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})

export class ReportService {

  className = 'ReportService';

  constructor(private http: HttpClient, private cacheService: CacheService) { }

  /*
  * Report Assessment
  */
  getAllReportAssessment(cache = true, cacheKey = "allReportAssessment"): Observable<RepAssessment[]> | any {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey);
    } else {
      let observable = this.http.get<RepAssessment[]>(environment.base_URL + "/types-valoration-report").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  newAssessment(assessment) {
    return this.http.post(environment.base_URL + "/types-valoration-report", assessment)
  }

  updateAssessment(assessment, id) {
    return this.http.put(environment.base_URL + `/types-valoration-report/${id}`, assessment)
  }

  /**
   *  Report sections
   */
  getAllReportSections(cache = true, cacheKey = "allReportSections"): Observable<RepAssessment[]> | any {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey);
    } else {
      let observable = this.http.get<RepAssessment[]>(environment.base_URL + "/types-structure-report").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  newReportSection(section) {
    return this.http.post(environment.base_URL + "/types-structure-report", section)
  }

  updateReportSection(section, id) {
    return this.http.put(environment.base_URL + `/types-structure-report/${id}`, section)
  }

  /**
 *  Report Type Extern
 */
  getAllExtRepType(cache = true, cacheKey = "allExtReportType"): Observable<RepAssessment[]> | any {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey);
    } else {
      let observable = this.http.get<RepAssessment[]>(environment.base_URL + "/external-report-types").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  newExtRepType(report) {
    return this.http.post(environment.base_URL + "/external-report-types", report)
  }

  updateExtRepType(report, id) {
    return this.http.put(environment.base_URL + `/external-report-types/${id}`, report)
  }

}

